<script>
  import { clipPathCode } from "$lib/utils/flowerClipath";

  /**@type {HTMLVideoElement}*/
  let video;
  let isPlay = false;

  const controls = () => {
    if (isPlay) {
      video.pause();
    } else {
      video.play();
    }
    isPlay = !isPlay;
  };
</script>

<section class="banner">
  <div class="banner-content">
    <div class="principal-banner">
      <video autoplay loop muted bind:this={video} playsinline>
        <source src="/videos/21358-RCM-SPRING-2025.mp4" />
      </video>
      <div class="banner-call-to-action">
        <h1>Must Haves <br /> For Gorgeous Nails</h1>
        <a href="/collections">
          GO TO SPRING COLLECTION
          <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45">
            <g id="Grupo_315" data-name="Grupo 315" transform="translate(0.159 0.01)">
              <circle
                id="Elipse_3"
                data-name="Elipse 3"
                cx="22.5"
                cy="22.5"
                r="22.5"
                transform="translate(-0.159 -0.01)"
                fill="var(--global)"
              />
              <path
                id="Path_228"
                data-name="Path 228"
                d="M-370.733,11847.706a.755.755,0,0,1-.461-.154.769.769,0,0,1-.152-1.076l8.717-11.587-8.711-11.239a.769.769,0,0,1,.137-1.078.768.768,0,0,1,1.077.137l9.429,12.166-.352.468-9.07,12.059A.767.767,0,0,1-370.733,11847.706Z"
                transform="translate(398.691 -11812.393)"
                fill="#fff"
              />
              <path
                id="Line_17"
                data-name="Line 17"
                d="M28.028.036H-.732A.768.768,0,0,1-1.5-.732.768.768,0,0,1-.732-1.5h28.76a.768.768,0,0,1,.768.768A.768.768,0,0,1,28.028.036Z"
                transform="translate(8.872 23.211)"
                fill="#fff"
              />
            </g>
          </svg>
        </a>
      </div>
      <button on:click={controls}></button>
    </div>
    <div class="tag">
      <h3>AT-HOME ESSENTIALS FOR THE <b>DIY GIRLY</b>!</h3>
      <img src="/images/svg/heart-invert.svg" alt="at home essentials" />
    </div>
  </div>
  <div class="new-collection-container">
    <div class="container-summer">
      <div class="content">
        <div class="video">
          <img
            style={`clip-path: polygon(${clipPathCode})`}
            src="/images/new_images/19868-RCM-SUM24-FP-EnvyOfTheTown-HandGlam-Photo-2.webp"
            alt="rcm home slide"
          />
        </div>
        <div class="right-content">
          <div class="text-container">
            <h2>It’s Glow Up Time!</h2>
            <p>
              Shop our newest launch for at-home nails! Whether you’re new to DIY or a nail genius,
              we’ve got something for you!
            </p>
            <a href="/collections">
              <svg xmlns="http://www.w3.org/2000/svg" width="58" height="58" viewBox="0 0 58 58">
                <g id="Grupo_319" data-name="Grupo 319" transform="translate(0.149)">
                  <circle
                    id="Elipse_3"
                    data-name="Elipse 3"
                    cx="29"
                    cy="29"
                    r="29"
                    transform="translate(-0.149)"
                    fill="var(--global)"
                  />
                  <path
                    id="Path_228"
                    data-name="Path 228"
                    d="M-370.515,11854.9a.981.981,0,0,1-.592-.2.986.986,0,0,1-.2-1.381l11.2-14.883L-371.293,11824a.986.986,0,0,1,.175-1.384.985.985,0,0,1,1.383.175l12.109,15.624-.453.6-11.648,15.485A.984.984,0,0,1-370.515,11854.9Z"
                    transform="translate(406.463 -11809.544)"
                    fill="#fcf3e8"
                  />
                  <path
                    id="Line_17"
                    data-name="Line 17"
                    d="M36.421.472H-.514A.986.986,0,0,1-1.5-.514.986.986,0,0,1-.514-1.5H36.421a.986.986,0,0,1,.986.986A.986.986,0,0,1,36.421.472Z"
                    transform="translate(11.01 29.382)"
                    fill="#fcf3e8"
                  />
                </g>
              </svg>
            </a>
          </div>
        </div>
        <div class="starts">
          <img src="/images/svg/stars.svg" alt="decoration starts" />
        </div>
        <div class="star">
          <img src="/images/svg/star.svg" alt="decoration start" />
        </div>
      </div>
    </div>
  </div>
</section>

<style>
  .banner {
    position: relative;
    z-index: 1;
  }
  .banner-content {
    width: 100svw;
    height: 100svh;
    display: grid;
    grid-template-rows: 90% 10%;
  }
  .principal-banner {
    width: 100svw;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    overflow: hidden;
  }
  .tag {
    background: transparent linear-gradient(90deg, #fdb048 0%, #fb5caa 100%) 0% 0% no-repeat
      padding-box;
    width: 100%;
    height: 100%;
    text-align: center;
    display: grid;
    grid-template-columns: 1fr 3fr 1fr;
    align-items: center;
    align-content: center;
    position: relative;
  }
  .tag h3 {
    grid-column: 2/3;
    color: var(--white);
    font-size: clamp(1.8rem, 5vw, 5rem);
    font-weight: 400;
    text-wrap: balance;
    line-height: 1;
    padding: 0;
    margin: 0;
  }
  .tag h3 b {
    font-weight: 700;
    line-height: 1;
  }
  .tag img {
    height: 200%;
    width: auto;
    aspect-ratio: 1/1;
    position: absolute;
    top: 50%;
    left: inherit;
    right: 3.5vw;
    transform: translateY(-50%);
    z-index: 1;
  }
  .principal-banner video {
    width: 100vw;
    height: 100vh;
    object-fit: cover;
    object-position: center;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: -2;
  }
  .principal-banner button {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: transparent;
    border: 0;
    z-index: 5;
  }
  .banner-call-to-action {
    color: var(--white);
    z-index: 99;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 0 5.8rem 0;
  }
  .banner-call-to-action a {
    cursor: pointer;
    text-decoration: none;
    color: var(--white);
    font-size: clamp(2.8rem, 2vw, 3.8rem);
    line-height: 1;
    display: grid;
    align-items: center;
    justify-content: center;
    grid-template-columns: 1fr 45px;
    gap: 2rem;
    text-shadow: 0 3px 3px rgba(0, 0, 0);
  }
  .banner-call-to-action h1 {
    font-size: clamp(4rem, 8svw, 13.6rem);
    font-family: "GentyRegular";
    line-height: 1;
    text-shadow: 0 6px 5px rgba(0, 0, 0);
    text-align: center;
  }
  .banner-call-to-action svg {
    margin: 0 0 0 0.5rem;
    width: 1.5vw;
    height: 1.5vw;
    min-width: 3rem;
    max-width: 3.8rem;
    aspect-ratio: 1/1;
  }
  @media (max-width: 1600px) {
    .banner-call-to-action {
      margin: 0 0 20rem 8rem;
    }
  }
  @media (max-width: 1024px) and (orientation: portrait) {
    .principal-banner {
      padding: 60px 0;
    }
    .tag {
      width: 100svw;
      display: flex;
      align-items: center;
      justify-content: space-around;
      padding: 0 20px;
    }
    .tag h3 {
      text-align: left;
    }
    .tag img {
      position: relative;
      transform: translate(0, 0);
      top: inherit;
      right: inherit;
    }
    .banner-call-to-action {
      margin: 0 0 0rem 6rem;
    }
  }
  @media (max-width: 768px) {
    .banner-content {
      height: 90svh;
    }
    .banner-call-to-action {
      margin: 0;
    }
  }
  @media (max-width: 767px) {
    .banner-call-to-action {
      display: grid;
      grid-template-rows: 2fr 1fr;
      justify-content: center;
      justify-items: center;
      align-content: center;
      align-items: center;
      width: 100svw;
      margin: 0 auto;
    }
    .banner-call-to-action a {
      gap: 1rem;
      font-size: 2.5rem;
    }
    .banner-call-to-action h1 {
      font-size: clamp(6rem, 15svw, 10rem);
      grid-column: 1/-1;
      text-align: center;
    }
    .banner-call-to-action svg {
      margin: 0;
      width: 4rem;
      height: 4rem;
    }
  }
  @media (max-width: 380px) {
    .banner-call-to-action h1 {
      font-size: clamp(5rem, 15svw, 20rem);
    }
  }
  .new-collection-container {
    position: relative;
    z-index: 0;
    display: flex;
    flex-direction: column;
    width: 100svw;
    padding: 10rem 0 6rem 0;
  }
  .container-summer {
    width: 100svw;
    height: 100%;
    background-color: var(--white);
  }
  .content {
    width: 100svw;
    background-color: #fff;
    position: relative;
    z-index: 3;
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-content: center;
    justify-items: center;
    align-items: center;
    padding-bottom: 6rem;
    max-width: 180rem;
    margin: 0 auto;
  }
  .content .video {
    width: 100%;
    aspect-ratio: 1/1;
    max-width: 100rem;
    overflow: hidden;
    position: relative;
  }
  .content .video img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    height: 90%;
    aspect-ratio: 1/1;
    z-index: -1;
    animation: slide 2000ms ease infinite;
  }
  .content .video img:nth-child(2) {
    animation-delay: 1000ms;
  }
  .content .video img:nth-child(3) {
    animation-delay: 3000ms;
  }
  .content .video img:nth-child(4) {
    animation-delay: 6000ms;
  }
  .content .video img:nth-child(5) {
    animation-delay: 9000ms;
  }
  .content .video img:nth-child(6) {
    animation-delay: 1500ms;
  }
  @keyframes slide {
    from {
      z-index: -1;
    }
    to {
      z-index: 1;
    }
  }
  .right-content {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-top: clamp(-5rem, -10svh, -10rem);
    gap: 5rem;
  }
  .text-container {
    align-self: flex-start;
  }
  .text-container h2 {
    font-family: "GentyRegular";
    color: var(--global);
    font-size: clamp(3.8rem, 8svw, 13.6rem);
    line-height: 1;
  }
  .text-container p {
    font-size: clamp(1.8rem, 2.5svw, 3.8rem);
    color: var(--global);
    max-width: 60rem;
    line-height: 1.2;
    margin-top: 0.5rem;
    color: var(--black);
  }
  .text-container svg {
    margin-top: 4.5rem;
    width: clamp(3rem, 4svw, 6rem);
    height: clamp(3rem, 4svw, 6rem);
  }
  .starts {
    position: absolute;
    top: 0;
    left: 45%;
    transform: translateX(-50%);
    z-index: 1;
    width: 5vw;
    height: 5vw;
    min-width: 116px;
    min-height: 116px;
  }
  .star {
    position: absolute;
    bottom: -7vw;
    right: 50px;
    width: 10vw;
    height: 10vw;
    z-index: 99;
  }
  @media (min-width: 1921px) {
    .text-container h2 {
      font-size: 14.5rem;
    }
    .text-container p {
      font-size: 3.8rem;
    }
  }
  @media (max-width: 580px) {
    .content {
      display: flex;
      flex-direction: column-reverse;
      justify-content: center;
      align-items: center;
    }
    .right-content {
      padding: 6rem 0 0 0;
      gap: 0;
      width: 100%;
    }
    .right-content .text-container {
      max-width: 85svw;
      margin: -4rem auto 0 auto;
      gap: 0;
    }
    .text-container h2 {
      font-size: 6rem;
      width: 80%;
    }
    .text-container p {
      font-size: 2.2rem;
      width: 90svw;
    }
    .content .video {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .text-container svg {
      margin-top: 2rem;
    }
  }
</style>
